export const removeDuplicateSlashes = (url: string, removeTrailingSlash = true) => {
  const sanitized = url.replace(/([^:]\/)\/+/g, '$1')
  return removeTrailingSlash ? sanitized.replace(/\/+$/, '') : sanitized
}
